/**
 *
 * jQuery Plugin to fetch random prices
 */

;(function($) {
    'use strict';

    $.fn.randomPrices = function(target) {
        return this.each(function() {
            var divs = $(this).find(target);
            var apiUrl = "/order/api/prices";
            var params = {count: divs.length}

            $.get(apiUrl, params, function(response) {
                var i, price;
                var data = response['data'];

                for (i = 0; i < data.length; i++) {
                    price = parseFloat(data[i]['price']).toFixed(3);

                    divs.eq(i).find('a').prop('href', '/order/' + data[i]['zip_code'] + '-' + data[i]['city'].replace(' ', '-'));
                    divs.eq(i).find('.city').text(data[i]['city'] + ', ' + data[i]['name']);
                    divs.eq(i).find('.price').text(price);

                }
            });
        });
    };
})(jQuery);